import categories from "./categories";
import brands from "./brands";
import products from "./products";
import branches from "./branches";
import orders from "./orders";

export default {
    categories, brands, products, branches, orders,
}